import { render, staticRenderFns } from "./QRCodeSettingsModal.vue?vue&type=template&id=28d06f7d&lang=pug"
import script from "./QRCodeSettingsModal.vue?vue&type=script&lang=js"
export * from "./QRCodeSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports